import React, { FunctionComponent, useState, useEffect, useRef, useCallback } from 'react';
import { Presentation } from './presentation';
import { getShowOtherBrandsByCompany } from '../../../services/brands';

type Props = {
  brandId: number;
  instagramIcon?: string;
  noimage: string;
  hoverIcon?: string;
  isPc?: boolean;
  dataCategory: {
    brandcontent?: string;
    stopbrandcontent: string;
  };
  dataValue: any;
};

export const Component: FunctionComponent<Props> = ({
  brandId,
  instagramIcon,
  noimage,
  hoverIcon,
  isPc,
  dataCategory,
  dataValue,
}) => {
  const [brandIds, setBrandIds] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getShouldShowArrows = () => {
    const count = brandIds.length;
    return isPc ? count >= 3 : count >= 2;
  };

  const request = useCallback(async () => {
    const response = await getShowOtherBrandsByCompany(brandId);
    setBrandIds(response.brandIds);
    setIsLoading(false);
  }, [brandId]);

  useEffect(() => {
    request();
  }, [request]);

  const sliderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (sliderRef.current && !$(sliderRef.current).hasClass('slick-initialized')) {
      const $brandsSlick: any = $(sliderRef.current);
      const shouldShowArrows = getShouldShowArrows();

      if (brandIds.length > 0 && $brandsSlick.slick) {
        $brandsSlick.slick({
          dots: false,
          arrows: shouldShowArrows,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0',
          variableWidth: true,
          autoplay: false,
          swipe: !isPc,
          touchMove: !isPc,
          prevArrow: '.brand-other__slider--prev',
          nextArrow: '.brand-other__slider--next',
          responsive: [
            {
              breakpoint: 929,
              settings: {
                arrows: false,
              },
            },
          ],
        });
      }
    }

    return () => {
      if (sliderRef.current && $(sliderRef.current).hasClass('slick-initialized')) {
        ($(sliderRef.current) as any).slick('unslick');
      }
    };
  }, [brandIds, isPc, getShouldShowArrows]);

  if (isLoading || !brandIds.length) {
    return null;
  }

  const shouldShowArrows = getShouldShowArrows();

  return (
    <Presentation
      brandIds={brandIds}
      instagramIcon={instagramIcon}
      noimage={noimage}
      hoverIcon={hoverIcon}
      isPc={isPc}
      dataCategory={dataCategory}
      dataValue={dataValue}
      shouldShowArrows={shouldShowArrows}
      sliderRef={sliderRef}
    />
  );
};
